import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { compose, withHandlers, withProps, withPropsOnChange, withState } from 'recompose';

import { prepareCommissionsForApi } from './helpers';
import { commissionFormName, validate } from './form';
import * as authSelectors from '../../../auth/selectors';
import { getShop, userUpdateShop } from '../../shops/actions';
import withNotifications from '../../../common/withNotifications';
import { saveCommissionTier, fetchCommissionTiers } from './actions';
import withFetchDataLoader from '../../../common/hoc/withFetchDataLoader';

export default compose(
  withNotifications,
  connect(
    state => ({
      shopId: authSelectors.getShop(state),
      productCommissionTiersType: formValueSelector(commissionFormName)(state, 'productCommissionTiersType'),
      serviceCommissionTiersType: formValueSelector(commissionFormName)(state, 'serviceCommissionTiersType'),
    }),
    {
      getShop,
      userUpdateShop,
      saveCommissionTier,
      fetchCommissionTiers,
    },
  ),
  withState('initialValues', 'setInitialValues', {}),
  withState('activeTab', 'setActiveTab', 'services'),
  withState('canSetFlatRate', 'setCanSetFlatRate', false),
  withHandlers({
    fetchData: props => async () => {
      const [shop, tiers] = await Promise.all([
        props.getShop(props.shopId, { include: 'commissionTiers' }),
        props.fetchCommissionTiers(props.shopId),
      ]);

      const initialValues = {
        ...tiers,
        cumulativeCommission: shop.cumulativeCommission,
      };

      const canSetFlatRate = !shop.commissionSplits;
      if (!canSetFlatRate) {
        initialValues.productCommissionTiersType = 'percentage';
      }

      // for services it's always percentage
      initialValues.serviceCommissionTiersType = 'percentage';

      props.setCanSetFlatRate(canSetFlatRate);
      props.setInitialValues(initialValues);
    },
  }),
  withHandlers({
    onSubmit: props => async (data) => {
      const payload = prepareCommissionsForApi(data);
      await Promise.all([
        props.saveCommissionTier(props.shopId, payload),
        props.userUpdateShop(props.shopId, { cumulativeCommission: data.cumulativeCommission }),
      ]);

      const commissions = await props.fetchData();

      props.addNotification({
        title: 'Success',
        level: 'success',
        message: 'Changes saved successfully',
      });

      return commissions;
    },
  }),
  withFetchDataLoader,
  reduxForm({
    form: commissionFormName,
    validate,
    enableReinitialize: true,
  }),
  withProps(props => ({
    baseUrl: '/settings',
    commissionTiersType: (
      props.activeTab === 'services'
        ? props.serviceCommissionTiersType
        : props.productCommissionTiersType
    ),
  })),
  withHandlers({
    changeCommissionType: props => (value) => {
      const key = props.activeTab === 'services' ? 'serviceCommissionTiersType' : 'productCommissionTiersType';
      props.change(key, value);
    },
  }),
  withPropsOnChange(
    ['activeTab'],
    (props) => {
      // don't allow flat amount tiers type for services
      const shouldForcePercentage = props.activeTab === 'services' && props.commissionTiersType === 'flatAmount';
      if (shouldForcePercentage) {
        props.changeCommissionType('percentage');
      }
    },
  ),
  withProps(props => ({
    // override the original value to forbid flat amount tiers type for services
    // it's a product decision and is only disabled by frontend
    canSetFlatRate: props.canSetFlatRate && props.activeTab !== 'services',
  })),
);

